// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"dc785040","425":"77778a61","510":"b9d7da95","532":"414d80e7","633":"2ec7ad8e","634":"8b76a9c8","922":"8cedf932","937":"5a1a85e8","972":"b893f020"}[chunkId] + ".chunk.js";
};